// G10 — Roteamento de erros 402 (quota_exceeded) do Assistente Geral.
//
// Espelha `quotaErrorHandler.ts` (Hub), mas com event/singleton PRÓPRIOS pra não
// colidir com o fluxo de cota do Hub (serviços e endpoints diferentes). Por que
// separado: o `QuotaErrorHost` global busca a cota em `/agents/quota/me/` e cria
// pedidos em `/agents/quota/requests/`. O Assistente tem tabela e endpoints
// próprios (`/assistant/quota/...`), então renderiza o próprio modal
// (`AssistantQuotaModal`, montado no `AssistantPage`).
//
// Disparado por:
//   1. `assistant.stream.ts` no 402 do stream (fetch direto — DT-12).
//   2. O interceptor 402 do axios, quando a URL é `/assistant/...` (ex.: upload de
//      anexo que estoura `uploads_daily`).

import { AssistantQuotaErrorResponse } from '@/types/assistant';

/** Evento custom — distinto do `quota:error` do Hub. */
export const ASSISTANT_QUOTA_ERROR_EVENT = 'assistant-quota:error';

export interface AssistantQuotaErrorEventDetail {
  payload: AssistantQuotaErrorResponse;
}

let _active = false;

/** Chamado pelo stream e pelo interceptor. Singleton: 2º 402 simultâneo é ignorado. */
export function handleAssistantQuotaError(payload: AssistantQuotaErrorResponse): void {
  if (typeof window === 'undefined') return;
  if (_active) return;
  _active = true;
  const detail: AssistantQuotaErrorEventDetail = { payload };
  window.dispatchEvent(
    new CustomEvent<AssistantQuotaErrorEventDetail>(ASSISTANT_QUOTA_ERROR_EVENT, { detail }),
  );
}

/** Chamado pelo modal ao fechar — libera o singleton. */
export function clearAssistantQuotaModal(): void {
  _active = false;
}

/** Helper só pra testes — reseta o singleton entre runs. */
export function _resetAssistantQuotaState(): void {
  _active = false;
}
